import { render, staticRenderFns } from "./withheldEntryNewForm.vue?vue&type=template&id=036d9faa&"
import script from "./withheldEntryNewForm.vue?vue&type=script&lang=js&"
export * from "./withheldEntryNewForm.vue?vue&type=script&lang=js&"
import style0 from "./withheldEntryNewForm.vue?vue&type=style&index=0&id=036d9faa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports